export default () => {
  return {
    chartFavoritesLocal: [],
    chartFavoritesRegional: [],
    chartFavoritesGlobal: [],
  };
};
